var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.stringFormatterRegexPattern"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Regular expression pattern",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.regex.pattern,
            callback: function ($$v) {
              _vm.$set(_vm.clone.regex, "pattern", $$v)
            },
            expression: "clone.regex.pattern",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.stringFormatterRegexEnterTheRegularExpressionPatternToMatch"
              )
            )
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.stringFormatterRegexFlags"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder:
              "Regular expression flags (e.g. 'g' for global, 'i' for case insensitive)",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.regex.flags,
            callback: function ($$v) {
              _vm.$set(_vm.clone.regex, "flags", $$v)
            },
            expression: "clone.regex.flags",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.stringFormatterRegexOptionalRegexFlagsGGlobalICaseInsensitiveMMultilineEtc"
              )
            )
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.stringFormatterRegexReplacementText"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Replacement text (only for regex replace operations)",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.regex.replace,
            callback: function ($$v) {
              _vm.$set(_vm.clone.regex, "replace", $$v)
            },
            expression: "clone.regex.replace",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.stringFormatterRegexReplaceMatchedTextWithThisValueLeaveEmptyToJustExtractMatches"
              )
            )
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(
            _vm._s(_vm.$t("auto.stringFormatterRegexMatchAllOccurrences"))
          ),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.regex.matchAll,
            callback: function ($$v) {
              _vm.$set(_vm.clone.regex, "matchAll", $$v)
            },
            expression: "clone.regex.matchAll",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.stringFormatterRegexWhenEnabledReturnsAllMatchesAsAnArrayInsteadOfJustTheFirstMatch"
              )
            )
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }